import { render, staticRenderFns } from "./Retailer.vue?vue&type=template&id=4d5cbd6c&scoped=true"
import script from "./Retailer.vue?vue&type=script&lang=js"
export * from "./Retailer.vue?vue&type=script&lang=js"
import style0 from "./Retailer.vue?vue&type=style&index=0&id=4d5cbd6c&prod&lang=scss&scoped=true"
import style1 from "./Retailer.vue?vue&type=style&index=1&id=4d5cbd6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5cbd6c",
  null
  
)

export default component.exports